import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import '../../../../styles/scss/style.css';

//Components
import Button from '../../atoms/Button';
import TextHeadingOne from '../../atoms/TextHeadingOne';
import TextParagraph from '../../atoms/TextParagraph';
// import DashboardPanelMenu from '../molecules/DashboardPanelMenu';
import SubjectBlock from '../../molecules/SubjectBlock';

//Returning the component
class SubjectListing extends Component {
	constructor(props) {
		super(props);

		this.selectSingleSubject = this.selectSingleSubject.bind(this);
	}
	selectSingleSubject(e, item, type) {
		var newItem = item;
		newItem.type = type;
		this.props.setSelectedSubject(newItem);
	}
	render() {
		return (
			<div className="dashboardPanelContainer">
				<div className="dashboardPanel">
				{/* <DashboardPanelMenu text={this.props.panelMenuText} href={this.props.panelMenuHref} /> */}
					<div className="dashboardPanel__content">
						<div className="dashboardPanel__mainContent">
							<TextHeadingOne text={this.props.heading} />
							<TextParagraph text={this.props.data.subjectListing.paragraph} />
							<Button classType="btn--small btn--iconLeft btn--marginRight btn--fullWidthMobile" text={this.props.data.subjectListing.addSubjectButton} href={this.props.href} iconLeft="fa-plus" onClick={this.props.addSubjectClick}/>
							{/* <Button classType="btn--small btn--iconLeft btn--fullWidthMobile btn--disabled" text={this.props.data.subjectListing.deleteSubjectButton} href={this.props.href} iconLeft="fa-trash"  /> */}
							<div className="margin-t-xs">
								{this.props.currentBot.subjects.map((singleSubject, i) => {
									return (
										<SubjectBlock 
											key={i} 
											subject={singleSubject.name} 
											special={singleSubject.special} 
											href={`${this.props.match.url}/${singleSubject._id}`} 
											onClickUpdate={(e) => this.selectSingleSubject(e, singleSubject, 'update')}
											onClickDelete={(e) => this.selectSingleSubject(e, singleSubject, 'delete')}
										/>
									)
								})}
							</div>
						</div>
					</div>
				</div>
			</div>

		)
	}
}



export default withRouter(SubjectListing);





// WEBPACK FOOTER //
// ./src/redux/components/organisms/SubjectListing/SubjectListing.jsx